import { render, staticRenderFns } from "./LinkCurved.vue?vue&type=template&id=0deeaf91&scoped=true&"
import script from "./LinkCurved.vue?vue&type=script&lang=js&"
export * from "./LinkCurved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deeaf91",
  null
  
)

export default component.exports